import { render, staticRenderFns } from "./BaseButtonIcon.vue?vue&type=template&id=202ae9cb&scoped=true&"
import script from "./BaseButtonIcon.vue?vue&type=script&lang=js&"
export * from "./BaseButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonIcon.vue?vue&type=style&index=0&id=202ae9cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ae9cb",
  null
  
)

export default component.exports